import React from 'react';
import Skeleton from 'react-loading-skeleton';

export default function SkeletonJobAdModelInfo() {
  return (
    <div>
      <div className="mb-32">
        <div className="mb-32 w-[358] h-[66] lg:w-[600] lg:h-[44]">
          <Skeleton className="mb32 h-full w-full" />
        </div>
        <div className="w-[358] h-[110] lg:w-[600] lg:h-[88]">
          <Skeleton className="mb-8 w-full h-full" />
        </div>
      </div>
      <div className="w-[358] h-[76] lg:w-[600] lg:h-[54] rounded-8! mb-32">
        <Skeleton className="rounded-8! w-full h-full" />
      </div>
      <div className="flex flex-col lg:flex-row justify-center gap-y-8 lg:gap-x-8 lg:mb-8">
        <div className="w-[358] h-[162] lg:w-[144] lg:h-[288]">
          <Skeleton className="rounded-8! w-full h-full" />
        </div>
        <div className="w-[358] h-[162] lg:w-[144] lg:h-[288]">
          <Skeleton className="rounded-8! w-full h-full" />
        </div>
        <div className="w-[358] h-[162] lg:w-[144] lg:h-[288]">
          <Skeleton className="rounded-8! w-full h-full" />
        </div>
        <div className="w-[358] h-[162] lg:w-[144] lg:h-[288]">
          <Skeleton className="rounded-8! w-full h-full" />
        </div>
      </div>
      <div className="mt-16 mb-32 w-[358] h-[44] lg:w-[600] lg:h-[44]">
        <Skeleton className="w-full h-full" />
      </div>
    </div>
  );
}
